<template>
  <material-card
    style="margin-top:30px"
    scrollable
    :title="$t('components.plancreationwizard.demographics_report_data_fields')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="pie_chart"
  >
    <v-card-text>
      <DualListBox
        :source="unselectedFieldsInternal"
        :destination="selectedFieldsInternal"
        label="Label"
        @onChangeList="onChangeList"
        :disabled="disabled"
      />
    </v-card-text>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapGetters } from "vuex";
import DualListBox from "dual-listbox-vue";
import "dual-listbox-vue/dist/dual-listbox.css";
import ErrorHandler from "@/components/ErrorHandler";
export default {
  components: {
    DualListBox,
    ErrorHandler,
  },
  props: ["selectedFields", "unselectedFields", "disabled"],
  data() {
    return {
      selectedFieldsInternal: [],
      unselectedFieldsInternal: [],
      error: null,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
  },
  watch: {
    selectedFields: {
      handler(v) {
        this.selectedFieldsInternal = v;
      },
    },
    unselectedFields: {
      handler(v) {
        this.unselectedFieldsInternal = v;
      },
    },
  },
  mounted() {
    this.selectedFieldsInternal = this.selectedFields;
    this.unselectedFieldsInternal = this.unselectedFields;
  },
  methods: {
    onChangeList: function({ source, destination }) {
      this.unselectedFieldsInternal = source;
      this.selectedFieldsInternal = destination;
      this.$emit("update-selection", this.selectedFieldsInternal);
    },
  },
};
</script>

<style></style>
